import React from "react";
import { Form } from "react-bootstrap";
import { markupPercent } from "./recipePricing";

export default function RecipePriceCells({ row, onChange }) {
  const markup = markupPercent(row.pret_magazie, row.pretvanzare);
  return <>
    <td><Form.Control aria-label="Preț magazie" size="sm" value={row.pret_magazie ?? ""} placeholder="—" readOnly
      title="Prețul lotului selectat din stoc. Pentru liniile vechi, reselectați piesa pentru a completa prețul." /></td>
    <td><Form.Control aria-label="Adaos (%)" type="number" size="sm" step="any" min={-100}
      value={markup ?? ""} placeholder="—" disabled={markup == null || row._priceLoading}
      title={markup == null ? "Adaosul procentual necesită un preț de magazie mai mare decât zero." : "Adaos procentual față de prețul de magazie"}
      onChange={(e) => onChange("adaos", e.target.value)} /></td>
  </>;
}
